module.exports = __webpack_public_path__ + "img/headBg.0b02a06c.jpg";